import { PeakType } from '@havenengineering/module-shared-owners-library/dist/enums/peakType';
const DisplayPeakTypeMapping = {
    [PeakType.OFF_PEAK]: 'Off-peak',
    [PeakType.PEAK]: 'Peak',
    [PeakType.SUPER_PEAK]: 'Super peak',
};
export const getDisplayPeakType = (peakType) => {
    return DisplayPeakTypeMapping[peakType];
};
